export const webSocektUrl = 'mcapi.coalsmine.com'